module.exports = __webpack_public_path__ + "static/img/talk.2f603b1f.png";